import { getMessages } from '../../../../../../../store/constants';

export const BOARD_EXPORT_BACKUPS_GOOGLE_SHEET = getMessages().getText('board_settings.export.backups.google_sheet');
